import { render } from "./UserReportTemplate.vue?vue&type=template&id=4e78e829"
import script from "./UserReportTemplate.vue?vue&type=script&lang=js"
export * from "./UserReportTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserReportTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e78e829"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e78e829', __exports__)) {
    api.reload('4e78e829', __exports__)
  }
  
  module.hot.accept("./UserReportTemplate.vue?vue&type=template&id=4e78e829", () => {
    api.rerender('4e78e829', render)
  })

}


export default __exports__